function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React, { FC, CSSProperties, Ref, RefObject } from 'react';
import cn from 'classnames';
require("./Separator.css");
var styles = {
  "Root": "Separator-module-Root_1bM",
  "Line": "Separator-module-Line_36_",
  "thinThickness": "Separator-module-thinThickness_1Vt",
  "thickThickness": "Separator-module-thickThickness_2qM",
  "shortWidth": "Separator-module-shortWidth_31v",
  "middleWidth": "Separator-module-middleWidth_25d",
  "longWidth": "Separator-module-longWidth_3DQ"
};
export const SeparatorThickness = {
  thin: 'thin',
  thick: 'thick'
};
export const SeparatorWidth = {
  short: 'short',
  middle: 'middle',
  long: 'long'
};
export const Separator = ({
  className,
  thickness,
  width,
  color,
  style = {},
  innerRef,
  controlRef,
  ...props
}) => {
  return /*#__PURE__*/React.createElement("div", _extends({
    ref: innerRef,
    className: cn(styles.Root, className)
  }, props), /*#__PURE__*/React.createElement("div", {
    ref: controlRef,
    style: {
      backgroundColor: color,
      ...style
    },
    className: cn(styles.Line, styles[`${thickness}Thickness`], styles[`${width}Width`])
  }));
};
if (process.env.NODE_ENV !== 'production') {
  Separator.displayName = 'Separator';
}